import { Component, OnInit } from '@angular/core';

import { SelectSnapshot } from '@ngxs-labs/select-snapshot';
import { BusinessState } from '@state/business';
import { ICON } from '@core/util/icon';
import { TestHooks } from './balance.hooks';
import { TeranetAccount } from '@models/teranet';
import { SelectedMatter } from '@state/matter/matter.selectors';
import { Select } from '@ngxs/store';
import { Observable } from 'rxjs';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
	selector: 'app-teranet-balance',
	templateUrl: './balance.component.html',
	styleUrls: ['./balance.component.scss'],
	standalone: false,
})
export class BalanceComponent implements OnInit {
	testHooks = TestHooks;

	@SelectSnapshot(BusinessState.getTeranetBalance) balance: number;
	@Select(SelectedMatter.getCurrentTeranetAccount)
	teranetAccount: Observable<TeranetAccount>;

	public currentBalance;
	public ICON = ICON;
	constructor() {}

	ngOnInit(): void {
		this.teranetAccount.pipe(untilDestroyed(this)).subscribe((account) => {
			this.currentBalance = account?.creditBalance || this.balance;
		});
	}
}
